import { render, staticRenderFns } from "./view-table.vue?vue&type=template&id=f2f6c2ec&scoped=true&"
import script from "./view-table.vue?vue&type=script&lang=js&"
export * from "./view-table.vue?vue&type=script&lang=js&"
import style0 from "./view-table.vue?vue&type=style&index=0&id=f2f6c2ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f6c2ec",
  null
  
)

export default component.exports